// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IActivateUserRequestModel {
    'userName': string;
    'activate': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IActivateUserRequestModel>> = [
        {
            "name":     "userName",
            "baseName": "userName",
            "type":     "string"
        },
        {
            "name":     "activate",
            "baseName": "activate",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return IActivateUserRequestModel.attributeTypeMap;
    }
}
